import { API_GRAPHQL } from "../../constants";
import { axiosAuthFetch } from "../../helpers/apiActions/authFetch";

export async function getServiceFormByProductId(productId) {
    const query = `
        query {
            serviceForms(filters: {product: {id: {eq: ${productId}}}}) {
                data {
                    id
                    attributes {
                        visual_check
                        service_checks {
                            data {
                                id
                                attributes {
                                    description
                                    category
                                }
                            }
                        }
                        product {
                            data {
                                attributes {
                                    name
                                    varenummer
                                    supplier {
                                        data {
                                            attributes {
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;

    try {
        const response = await axiosAuthFetch(`${API_GRAPHQL}`, {query}, 'POST');
        return response.data;
    } catch(error) {
        console.error(error)
        return null;
    }
}